import * as React from "react"
import styled from "styled-components"
import { space } from "styled-system"
import cn from "classnames"
import injectSheet from "react-jss"
import { color } from "@xingternal/360-styles/helpers"
import { Text } from "@xingternal/360-components"

const styles = {
  container: {
    composes:
      "background-white p16 flex justify-between items-start ff-xing-sans level1 z3",
  },
  title: {
    "&:not(:last-child)": {
      paddingBottom: 8,
    },
  },
}

const Spacer = styled.div.attrs({ mx: "auto" })`
  ${space}
`

const PageHeader = ({
  actions,
  classes,
  className,
  description,
  id,
  title,
}) => (
  <div className={cn(className, classes.container)} id={id}>
    <div className={classes.main}>
      <Text className={classes.title} size={22} color={color("gray-80")}>
        {title}
      </Text>
      {description && (
        <Text
          className={classes.description}
          size={13}
          color={color("gray-50")}
        >
          {description}
        </Text>
      )}
    </div>
    <Spacer />
    {actions}
  </div>
)

export const StyledPageHeader = injectSheet(styles)(PageHeader)
export default PageHeader
